/**
 * Auto-generated Zod schema for RepositoryVulnerabilityAlertAlert
 * DO NOT MODIFY - regenerate with: bun run generate:schemas
 */

import type { RepositoryVulnerabilityAlertAlert as RepositoryVulnerabilityAlertAlertOctokit } from '@octokit/webhooks-types';
import { z } from 'zod';

import { UserSchema } from './user.js';

export const RepositoryVulnerabilityAlertAlertSchema = z.object({
  id: z.number(),
  number: z.number(),
  node_id: z.string(),
  state: z.union([z.literal('open'), z.literal('dismissed'), z.literal('fixed')]),
  affected_range: z.string(),
  affected_package_name: z.string(),
  dismisser: UserSchema.optional(),
  dismiss_reason: z.string().optional(),
  dismissed_at: z.string().optional(),
  severity: z.string(),
  ghsa_id: z.string(),
  external_reference: z.string(),
  external_identifier: z.string(),
  fixed_in: z.string().optional(),
  fixed_at: z.string().optional(),
  fix_reason: z.string().optional(),
  created_at: z.string(),
}) satisfies z.ZodType<RepositoryVulnerabilityAlertAlertOctokit>;

export type RepositoryVulnerabilityAlertAlert = RepositoryVulnerabilityAlertAlertOctokit;

export function isRepositoryVulnerabilityAlertAlert(
  value: unknown,
): value is RepositoryVulnerabilityAlertAlert {
  return RepositoryVulnerabilityAlertAlertSchema.safeParse(value).success;
}
